// Comprehensive city list for one-way taxi search (100+ cities)

const oneWayCityOptions = [
  'Abohar',
  'Adampur',
  'Ahmedgarh',
  'Ambala',
  'Ambala Railway Station',
  'Amloh',
  'Amritsar',
  'Amritsar Airport',
  'Anandpur Sahib',
  'Baba Bakala',
  'Baddi',
  'Bahadurgarh',
  'Balachaur',
  'Banga',
  'Banur',
  'Barnala',
  'Batala',
  'Bathinda',
  'Beas',
  'Bhawanigarh',
  'Bir',
  'Budhlada',
  'Chamba',
  'Chamkaur sahib',
  'Chandigarh',
  'Chandigarh Airport',
  'Chandigarh Railway Station',
  'Chintpurni',
  'Dalhousie',
  'Dasuya',
  'Dehradun',
  'Delhi',
  'Delhi Airport',
  'Delhi Railway Station',
  'Dera Baba Nanak',
  'Dera Bassi',
  'Dharamkot',
  'Dhuri',
  'Doraha',
  'Faridabad',
  'Faridkot',
  'Fatehgarh Sahib',
  'Fazilka',
  'Firozpur',
  'Garhshankar',
  'Ghaziabad',
  'Gidderbaha',
  'Gobindgarh',
  'Golden Temple Amritsar',
  'Greater Noida',
  'Gurdaspur',
  'Gurgaon',
  'Gurugram',
  'Haldwani',
  'Hamirpur',
  'Haridwar',
  'Hazrat Nizamuddin Railway Station',
  'Hoshiarpur',
  'Jagraon',
  'Jalandhar',
  'Jammu',
  'Jawalamukhi',
  'Kaithal',
  'Kalka',
  'Kangra',
  'Kapurthala',
  'Kasauli',
  'Kashipur',
  'Kasol',
  'Khadur Sahib',
  'Khamanon',
  'Khanna',
  'Kharar',
  'Kiratpur sahib',
  'Kot Kapura',
  'Kotdwar',
  'Kufri',
  'Kullu',
  'Kurali',
  'Kurukshetra',
  'Lehra',
  'Lehragaga',
  'Lucknow',
  'Ludhiana',
  'Malerkotla',
  'Malout',
  'Manali',
  'Mandi',
  'Manikaran',
  'Mansa',
  'Mashobra',
  'Mathura',
  'Mcleodganj',
  'Meerut',
  'Moga',
  'Mohali',
  'Mohali Airport',
  'Morinda',
  'Mukerian',
  'Murthal',
  'Mussoorie',
  'Nabha',
  'Nadaun',
  'Nahan',
  'Naina Devi',
  'Nainital',
  'Nakodar',
  'Nangal',
  'Narkanda',
  'Nawanshahr'
];

export default oneWayCityOptions;